import React from "react";
import { Link } from "react-router-dom";

const STATS = [
  { v: "7", l: "Workflows" },
  { v: "Part 11", l: "21 CFR Ready" },
  { v: "97.8%", l: "Audit Score" },
  { v: "50+", l: "AI Agents" },
];

export default function DemoHero({ theme, onToggleTheme }) {
  return (
    <>
      <header className="lcx-header">
        <div className="lcx-header-inner">
          <Link
            to="/client-portal"
            aria-label="Back to Client Portal"
            style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem", fontSize: "0.8rem", fontWeight: 600, textDecoration: "none", color: "inherit", opacity: 0.8, marginRight: "0.75rem" }}
          >
            ← Client Portal
          </Link>
          <div className="lcx-brand">
            <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true">
              <rect width="30" height="30" rx="7" fill="#161b27" stroke="rgba(255,255,255,0.14)" />
              <polyline points="5,21 11,15 16,18 25,8" fill="none" stroke="#00d4aa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="11" cy="15" r="2" fill="#00d4aa" />
              <circle cx="16" cy="18" r="2" fill="#4f8fff" />
              <circle cx="25" cy="8" r="2" fill="#a78bfa" />
            </svg>
            <span>LabComplyx</span>
            <span className="lcx-live-badge">Live Demo</span>
          </div>
          <div className="lcx-header-actions">
            <Link
              to="/portal-preview"
              style={{ display: "inline-flex", alignItems: "center", gap: "0.3rem", fontSize: "0.8rem", fontWeight: 600, textDecoration: "none", color: "inherit", opacity: 0.85, marginRight: "0.5rem" }}
            >
              Explore the Portal →
            </Link>
            <button type="button" className="lcx-theme-btn" onClick={onToggleTheme} aria-label="Toggle dark/light mode">
              {theme === "dark" ? "☀️" : "🌙"}
            </button>
            <Link to="/gap-assessment" className="lcx-cta">Request Full Access →</Link>
          </div>
        </div>
      </header>

      <section className="lcx-hero">
        <span className="lcx-eyebrow"><span className="dot" /> A Self-Operating Quality System — Governed, Gated, Audit-Provable</span>
        <h1>Watch <span className="hl">Quality Work Run Itself</span> — From First Trigger to Audit-Ready Proof</h1>
        <p>
          This isn't faster documentation — it's a redesigned operating model. Watch a deviation investigate
          itself, arrive pre-drafted at a human sign-off gate, and leave behind an immutable evidence trail,
          with every regulatory guardrail enforced in real time.
        </p>
        <div className="lcx-stats">
          {STATS.map((s) => (
            <div key={s.l} className="lcx-stat">
              <div className="v">{s.v}</div>
              <div className="l">{s.l}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}